export default "__VITE_ASSET__DNTXwY$2__"